/**
 * @fileoverview gRPC-Web generated client stub for request
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: request/request.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var common_collections_pb = require('../common/collections_pb.js')

var common_model_pb = require('../common/model_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')

var attachment_attachment_pb = require('../attachment/attachment_pb.js')

var vendormanagement_attestation_pb = require('../vendormanagement/attestation_pb.js')
const proto = {};
proto.request = require('./request_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.request.RequestClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.request.RequestPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.CreateOrUpdateDocumentRequestRequest,
 *   !proto.request.DocumentRequest>}
 */
const methodDescriptor_Request_CreateOrUpdateDocumentRequest = new grpc.web.MethodDescriptor(
  '/request.Request/CreateOrUpdateDocumentRequest',
  grpc.web.MethodType.UNARY,
  proto.request.CreateOrUpdateDocumentRequestRequest,
  proto.request.DocumentRequest,
  /**
   * @param {!proto.request.CreateOrUpdateDocumentRequestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.DocumentRequest.deserializeBinary
);


/**
 * @param {!proto.request.CreateOrUpdateDocumentRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.DocumentRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.DocumentRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.createOrUpdateDocumentRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/CreateOrUpdateDocumentRequest',
      request,
      metadata || {},
      methodDescriptor_Request_CreateOrUpdateDocumentRequest,
      callback);
};


/**
 * @param {!proto.request.CreateOrUpdateDocumentRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.DocumentRequest>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.createOrUpdateDocumentRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/CreateOrUpdateDocumentRequest',
      request,
      metadata || {},
      methodDescriptor_Request_CreateOrUpdateDocumentRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.DocumentRequest,
 *   !proto.request.DocumentRequest>}
 */
const methodDescriptor_Request_CreateDocumentRequest = new grpc.web.MethodDescriptor(
  '/request.Request/CreateDocumentRequest',
  grpc.web.MethodType.UNARY,
  proto.request.DocumentRequest,
  proto.request.DocumentRequest,
  /**
   * @param {!proto.request.DocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.DocumentRequest.deserializeBinary
);


/**
 * @param {!proto.request.DocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.DocumentRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.DocumentRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.createDocumentRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/CreateDocumentRequest',
      request,
      metadata || {},
      methodDescriptor_Request_CreateDocumentRequest,
      callback);
};


/**
 * @param {!proto.request.DocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.DocumentRequest>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.createDocumentRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/CreateDocumentRequest',
      request,
      metadata || {},
      methodDescriptor_Request_CreateDocumentRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.UpdateDocumentRequestRequest,
 *   !proto.request.DocumentRequest>}
 */
const methodDescriptor_Request_UpdateDocumentRequest = new grpc.web.MethodDescriptor(
  '/request.Request/UpdateDocumentRequest',
  grpc.web.MethodType.UNARY,
  proto.request.UpdateDocumentRequestRequest,
  proto.request.DocumentRequest,
  /**
   * @param {!proto.request.UpdateDocumentRequestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.DocumentRequest.deserializeBinary
);


/**
 * @param {!proto.request.UpdateDocumentRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.DocumentRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.DocumentRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.updateDocumentRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/UpdateDocumentRequest',
      request,
      metadata || {},
      methodDescriptor_Request_UpdateDocumentRequest,
      callback);
};


/**
 * @param {!proto.request.UpdateDocumentRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.DocumentRequest>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.updateDocumentRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/UpdateDocumentRequest',
      request,
      metadata || {},
      methodDescriptor_Request_UpdateDocumentRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.ListDocumentRequestsRequest,
 *   !proto.request.DocumentRequests>}
 */
const methodDescriptor_Request_ListDocumentRequests = new grpc.web.MethodDescriptor(
  '/request.Request/ListDocumentRequests',
  grpc.web.MethodType.UNARY,
  proto.request.ListDocumentRequestsRequest,
  proto.request.DocumentRequests,
  /**
   * @param {!proto.request.ListDocumentRequestsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.DocumentRequests.deserializeBinary
);


/**
 * @param {!proto.request.ListDocumentRequestsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.DocumentRequests)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.DocumentRequests>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.listDocumentRequests =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/ListDocumentRequests',
      request,
      metadata || {},
      methodDescriptor_Request_ListDocumentRequests,
      callback);
};


/**
 * @param {!proto.request.ListDocumentRequestsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.DocumentRequests>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.listDocumentRequests =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/ListDocumentRequests',
      request,
      metadata || {},
      methodDescriptor_Request_ListDocumentRequests);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.DeleteDocumentRequestRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_DeleteDocumentRequest = new grpc.web.MethodDescriptor(
  '/request.Request/DeleteDocumentRequest',
  grpc.web.MethodType.UNARY,
  proto.request.DeleteDocumentRequestRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.DeleteDocumentRequestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.DeleteDocumentRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.deleteDocumentRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/DeleteDocumentRequest',
      request,
      metadata || {},
      methodDescriptor_Request_DeleteDocumentRequest,
      callback);
};


/**
 * @param {!proto.request.DeleteDocumentRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.deleteDocumentRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/DeleteDocumentRequest',
      request,
      metadata || {},
      methodDescriptor_Request_DeleteDocumentRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.ListDocumentRequestsRequest,
 *   !proto.request.CountDocumentRequestsResponse>}
 */
const methodDescriptor_Request_CountDocumentRequests = new grpc.web.MethodDescriptor(
  '/request.Request/CountDocumentRequests',
  grpc.web.MethodType.UNARY,
  proto.request.ListDocumentRequestsRequest,
  proto.request.CountDocumentRequestsResponse,
  /**
   * @param {!proto.request.ListDocumentRequestsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.CountDocumentRequestsResponse.deserializeBinary
);


/**
 * @param {!proto.request.ListDocumentRequestsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.CountDocumentRequestsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.CountDocumentRequestsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.countDocumentRequests =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/CountDocumentRequests',
      request,
      metadata || {},
      methodDescriptor_Request_CountDocumentRequests,
      callback);
};


/**
 * @param {!proto.request.ListDocumentRequestsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.CountDocumentRequestsResponse>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.countDocumentRequests =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/CountDocumentRequests',
      request,
      metadata || {},
      methodDescriptor_Request_CountDocumentRequests);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.LinkControlsToRequestRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_LinkControlsToRequest = new grpc.web.MethodDescriptor(
  '/request.Request/LinkControlsToRequest',
  grpc.web.MethodType.UNARY,
  proto.request.LinkControlsToRequestRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.LinkControlsToRequestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.LinkControlsToRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.linkControlsToRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/LinkControlsToRequest',
      request,
      metadata || {},
      methodDescriptor_Request_LinkControlsToRequest,
      callback);
};


/**
 * @param {!proto.request.LinkControlsToRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.linkControlsToRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/LinkControlsToRequest',
      request,
      metadata || {},
      methodDescriptor_Request_LinkControlsToRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.LinkRequestsToControlRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_LinkRequestsToControl = new grpc.web.MethodDescriptor(
  '/request.Request/LinkRequestsToControl',
  grpc.web.MethodType.UNARY,
  proto.request.LinkRequestsToControlRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.LinkRequestsToControlRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.LinkRequestsToControlRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.linkRequestsToControl =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/LinkRequestsToControl',
      request,
      metadata || {},
      methodDescriptor_Request_LinkRequestsToControl,
      callback);
};


/**
 * @param {!proto.request.LinkRequestsToControlRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.linkRequestsToControl =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/LinkRequestsToControl',
      request,
      metadata || {},
      methodDescriptor_Request_LinkRequestsToControl);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.UnlinkControlFromRequestRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_UnlinkControlFromRequest = new grpc.web.MethodDescriptor(
  '/request.Request/UnlinkControlFromRequest',
  grpc.web.MethodType.UNARY,
  proto.request.UnlinkControlFromRequestRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.UnlinkControlFromRequestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.UnlinkControlFromRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.unlinkControlFromRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/UnlinkControlFromRequest',
      request,
      metadata || {},
      methodDescriptor_Request_UnlinkControlFromRequest,
      callback);
};


/**
 * @param {!proto.request.UnlinkControlFromRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.unlinkControlFromRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/UnlinkControlFromRequest',
      request,
      metadata || {},
      methodDescriptor_Request_UnlinkControlFromRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.BulkCreateDocumentRequestsRequest,
 *   !proto.request.DocumentRequests>}
 */
const methodDescriptor_Request_BulkCreateDocumentRequests = new grpc.web.MethodDescriptor(
  '/request.Request/BulkCreateDocumentRequests',
  grpc.web.MethodType.UNARY,
  proto.request.BulkCreateDocumentRequestsRequest,
  proto.request.DocumentRequests,
  /**
   * @param {!proto.request.BulkCreateDocumentRequestsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.DocumentRequests.deserializeBinary
);


/**
 * @param {!proto.request.BulkCreateDocumentRequestsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.DocumentRequests)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.DocumentRequests>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.bulkCreateDocumentRequests =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/BulkCreateDocumentRequests',
      request,
      metadata || {},
      methodDescriptor_Request_BulkCreateDocumentRequests,
      callback);
};


/**
 * @param {!proto.request.BulkCreateDocumentRequestsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.DocumentRequests>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.bulkCreateDocumentRequests =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/BulkCreateDocumentRequests',
      request,
      metadata || {},
      methodDescriptor_Request_BulkCreateDocumentRequests);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.LinkPoliciesToRequestRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_LinkPoliciesToRequest = new grpc.web.MethodDescriptor(
  '/request.Request/LinkPoliciesToRequest',
  grpc.web.MethodType.UNARY,
  proto.request.LinkPoliciesToRequestRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.LinkPoliciesToRequestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.LinkPoliciesToRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.linkPoliciesToRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/LinkPoliciesToRequest',
      request,
      metadata || {},
      methodDescriptor_Request_LinkPoliciesToRequest,
      callback);
};


/**
 * @param {!proto.request.LinkPoliciesToRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.linkPoliciesToRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/LinkPoliciesToRequest',
      request,
      metadata || {},
      methodDescriptor_Request_LinkPoliciesToRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.UnlinkPolicyFromRequestRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_UnlinkPolicyFromRequest = new grpc.web.MethodDescriptor(
  '/request.Request/UnlinkPolicyFromRequest',
  grpc.web.MethodType.UNARY,
  proto.request.UnlinkPolicyFromRequestRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.UnlinkPolicyFromRequestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.UnlinkPolicyFromRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.unlinkPolicyFromRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/UnlinkPolicyFromRequest',
      request,
      metadata || {},
      methodDescriptor_Request_UnlinkPolicyFromRequest,
      callback);
};


/**
 * @param {!proto.request.UnlinkPolicyFromRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.unlinkPolicyFromRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/UnlinkPolicyFromRequest',
      request,
      metadata || {},
      methodDescriptor_Request_UnlinkPolicyFromRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.LinkVendorsToRequestRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_LinkVendorsToRequest = new grpc.web.MethodDescriptor(
  '/request.Request/LinkVendorsToRequest',
  grpc.web.MethodType.UNARY,
  proto.request.LinkVendorsToRequestRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.LinkVendorsToRequestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.LinkVendorsToRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.linkVendorsToRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/LinkVendorsToRequest',
      request,
      metadata || {},
      methodDescriptor_Request_LinkVendorsToRequest,
      callback);
};


/**
 * @param {!proto.request.LinkVendorsToRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.linkVendorsToRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/LinkVendorsToRequest',
      request,
      metadata || {},
      methodDescriptor_Request_LinkVendorsToRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.UnlinkVendorFromRequestRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_UnlinkVendorFromRequest = new grpc.web.MethodDescriptor(
  '/request.Request/UnlinkVendorFromRequest',
  grpc.web.MethodType.UNARY,
  proto.request.UnlinkVendorFromRequestRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.UnlinkVendorFromRequestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.UnlinkVendorFromRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.unlinkVendorFromRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/UnlinkVendorFromRequest',
      request,
      metadata || {},
      methodDescriptor_Request_UnlinkVendorFromRequest,
      callback);
};


/**
 * @param {!proto.request.UnlinkVendorFromRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.unlinkVendorFromRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/UnlinkVendorFromRequest',
      request,
      metadata || {},
      methodDescriptor_Request_UnlinkVendorFromRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.LinkRisksToRequestRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_LinkRisksToRequest = new grpc.web.MethodDescriptor(
  '/request.Request/LinkRisksToRequest',
  grpc.web.MethodType.UNARY,
  proto.request.LinkRisksToRequestRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.LinkRisksToRequestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.LinkRisksToRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.linkRisksToRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/LinkRisksToRequest',
      request,
      metadata || {},
      methodDescriptor_Request_LinkRisksToRequest,
      callback);
};


/**
 * @param {!proto.request.LinkRisksToRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.linkRisksToRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/LinkRisksToRequest',
      request,
      metadata || {},
      methodDescriptor_Request_LinkRisksToRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.UnlinkRiskFromRequestRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_UnlinkRiskFromRequest = new grpc.web.MethodDescriptor(
  '/request.Request/UnlinkRiskFromRequest',
  grpc.web.MethodType.UNARY,
  proto.request.UnlinkRiskFromRequestRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.UnlinkRiskFromRequestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.UnlinkRiskFromRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.unlinkRiskFromRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/UnlinkRiskFromRequest',
      request,
      metadata || {},
      methodDescriptor_Request_UnlinkRiskFromRequest,
      callback);
};


/**
 * @param {!proto.request.UnlinkRiskFromRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.unlinkRiskFromRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/UnlinkRiskFromRequest',
      request,
      metadata || {},
      methodDescriptor_Request_UnlinkRiskFromRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.RequestDocument,
 *   !proto.request.RequestDocument>}
 */
const methodDescriptor_Request_CreateRequestDocument = new grpc.web.MethodDescriptor(
  '/request.Request/CreateRequestDocument',
  grpc.web.MethodType.UNARY,
  proto.request.RequestDocument,
  proto.request.RequestDocument,
  /**
   * @param {!proto.request.RequestDocument} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.RequestDocument.deserializeBinary
);


/**
 * @param {!proto.request.RequestDocument} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.RequestDocument)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.RequestDocument>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.createRequestDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/CreateRequestDocument',
      request,
      metadata || {},
      methodDescriptor_Request_CreateRequestDocument,
      callback);
};


/**
 * @param {!proto.request.RequestDocument} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.RequestDocument>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.createRequestDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/CreateRequestDocument',
      request,
      metadata || {},
      methodDescriptor_Request_CreateRequestDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.ListRequestDocumentsRequest,
 *   !proto.request.RequestDocuments>}
 */
const methodDescriptor_Request_ListRequestDocuments = new grpc.web.MethodDescriptor(
  '/request.Request/ListRequestDocuments',
  grpc.web.MethodType.UNARY,
  proto.request.ListRequestDocumentsRequest,
  proto.request.RequestDocuments,
  /**
   * @param {!proto.request.ListRequestDocumentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.RequestDocuments.deserializeBinary
);


/**
 * @param {!proto.request.ListRequestDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.RequestDocuments)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.RequestDocuments>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.listRequestDocuments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/ListRequestDocuments',
      request,
      metadata || {},
      methodDescriptor_Request_ListRequestDocuments,
      callback);
};


/**
 * @param {!proto.request.ListRequestDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.RequestDocuments>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.listRequestDocuments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/ListRequestDocuments',
      request,
      metadata || {},
      methodDescriptor_Request_ListRequestDocuments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.DeleteRequestDocumentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_DeleteRequestDocument = new grpc.web.MethodDescriptor(
  '/request.Request/DeleteRequestDocument',
  grpc.web.MethodType.UNARY,
  proto.request.DeleteRequestDocumentRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.DeleteRequestDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.DeleteRequestDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.deleteRequestDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/DeleteRequestDocument',
      request,
      metadata || {},
      methodDescriptor_Request_DeleteRequestDocument,
      callback);
};


/**
 * @param {!proto.request.DeleteRequestDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.deleteRequestDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/DeleteRequestDocument',
      request,
      metadata || {},
      methodDescriptor_Request_DeleteRequestDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.CreateAndLinkRequestPolicyDocRequest,
 *   !proto.request.RequestPolicyDoc>}
 */
const methodDescriptor_Request_CreateAndLinkRequestPolicyDoc = new grpc.web.MethodDescriptor(
  '/request.Request/CreateAndLinkRequestPolicyDoc',
  grpc.web.MethodType.UNARY,
  proto.request.CreateAndLinkRequestPolicyDocRequest,
  proto.request.RequestPolicyDoc,
  /**
   * @param {!proto.request.CreateAndLinkRequestPolicyDocRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.RequestPolicyDoc.deserializeBinary
);


/**
 * @param {!proto.request.CreateAndLinkRequestPolicyDocRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.RequestPolicyDoc)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.RequestPolicyDoc>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.createAndLinkRequestPolicyDoc =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/CreateAndLinkRequestPolicyDoc',
      request,
      metadata || {},
      methodDescriptor_Request_CreateAndLinkRequestPolicyDoc,
      callback);
};


/**
 * @param {!proto.request.CreateAndLinkRequestPolicyDocRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.RequestPolicyDoc>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.createAndLinkRequestPolicyDoc =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/CreateAndLinkRequestPolicyDoc',
      request,
      metadata || {},
      methodDescriptor_Request_CreateAndLinkRequestPolicyDoc);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.ListRequestPolicyDocsRequest,
 *   !proto.request.RequestPolicyDocs>}
 */
const methodDescriptor_Request_ListRequestPolicyDocs = new grpc.web.MethodDescriptor(
  '/request.Request/ListRequestPolicyDocs',
  grpc.web.MethodType.UNARY,
  proto.request.ListRequestPolicyDocsRequest,
  proto.request.RequestPolicyDocs,
  /**
   * @param {!proto.request.ListRequestPolicyDocsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.RequestPolicyDocs.deserializeBinary
);


/**
 * @param {!proto.request.ListRequestPolicyDocsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.RequestPolicyDocs)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.RequestPolicyDocs>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.listRequestPolicyDocs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/ListRequestPolicyDocs',
      request,
      metadata || {},
      methodDescriptor_Request_ListRequestPolicyDocs,
      callback);
};


/**
 * @param {!proto.request.ListRequestPolicyDocsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.RequestPolicyDocs>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.listRequestPolicyDocs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/ListRequestPolicyDocs',
      request,
      metadata || {},
      methodDescriptor_Request_ListRequestPolicyDocs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.DeleteRequestPolicyDocRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_DeleteRequestPolicyDoc = new grpc.web.MethodDescriptor(
  '/request.Request/DeleteRequestPolicyDoc',
  grpc.web.MethodType.UNARY,
  proto.request.DeleteRequestPolicyDocRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.DeleteRequestPolicyDocRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.DeleteRequestPolicyDocRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.deleteRequestPolicyDoc =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/DeleteRequestPolicyDoc',
      request,
      metadata || {},
      methodDescriptor_Request_DeleteRequestPolicyDoc,
      callback);
};


/**
 * @param {!proto.request.DeleteRequestPolicyDocRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.deleteRequestPolicyDoc =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/DeleteRequestPolicyDoc',
      request,
      metadata || {},
      methodDescriptor_Request_DeleteRequestPolicyDoc);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.CreateAndLinkRequestAttestationRequest,
 *   !proto.request.CreateAndLinkRequestAttestationResponse>}
 */
const methodDescriptor_Request_CreateAndLinkRequestAttestation = new grpc.web.MethodDescriptor(
  '/request.Request/CreateAndLinkRequestAttestation',
  grpc.web.MethodType.UNARY,
  proto.request.CreateAndLinkRequestAttestationRequest,
  proto.request.CreateAndLinkRequestAttestationResponse,
  /**
   * @param {!proto.request.CreateAndLinkRequestAttestationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.CreateAndLinkRequestAttestationResponse.deserializeBinary
);


/**
 * @param {!proto.request.CreateAndLinkRequestAttestationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.CreateAndLinkRequestAttestationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.CreateAndLinkRequestAttestationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.createAndLinkRequestAttestation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/CreateAndLinkRequestAttestation',
      request,
      metadata || {},
      methodDescriptor_Request_CreateAndLinkRequestAttestation,
      callback);
};


/**
 * @param {!proto.request.CreateAndLinkRequestAttestationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.CreateAndLinkRequestAttestationResponse>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.createAndLinkRequestAttestation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/CreateAndLinkRequestAttestation',
      request,
      metadata || {},
      methodDescriptor_Request_CreateAndLinkRequestAttestation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.ListRequestAttestationsRequest,
 *   !proto.vendormanagement.Attestations>}
 */
const methodDescriptor_Request_ListRequestAttestations = new grpc.web.MethodDescriptor(
  '/request.Request/ListRequestAttestations',
  grpc.web.MethodType.UNARY,
  proto.request.ListRequestAttestationsRequest,
  vendormanagement_attestation_pb.Attestations,
  /**
   * @param {!proto.request.ListRequestAttestationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  vendormanagement_attestation_pb.Attestations.deserializeBinary
);


/**
 * @param {!proto.request.ListRequestAttestationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vendormanagement.Attestations)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vendormanagement.Attestations>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.listRequestAttestations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/ListRequestAttestations',
      request,
      metadata || {},
      methodDescriptor_Request_ListRequestAttestations,
      callback);
};


/**
 * @param {!proto.request.ListRequestAttestationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vendormanagement.Attestations>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.listRequestAttestations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/ListRequestAttestations',
      request,
      metadata || {},
      methodDescriptor_Request_ListRequestAttestations);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.DeleteRequestAttestationRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_DeleteRequestAttestation = new grpc.web.MethodDescriptor(
  '/request.Request/DeleteRequestAttestation',
  grpc.web.MethodType.UNARY,
  proto.request.DeleteRequestAttestationRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.DeleteRequestAttestationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.DeleteRequestAttestationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.deleteRequestAttestation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/DeleteRequestAttestation',
      request,
      metadata || {},
      methodDescriptor_Request_DeleteRequestAttestation,
      callback);
};


/**
 * @param {!proto.request.DeleteRequestAttestationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.deleteRequestAttestation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/DeleteRequestAttestation',
      request,
      metadata || {},
      methodDescriptor_Request_DeleteRequestAttestation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.GetSuggestedEvidenceForRequestReq,
 *   !proto.request.GetSuggestedEvidenceForRequestRes>}
 */
const methodDescriptor_Request_GetSuggestedEvidenceForRequest = new grpc.web.MethodDescriptor(
  '/request.Request/GetSuggestedEvidenceForRequest',
  grpc.web.MethodType.UNARY,
  proto.request.GetSuggestedEvidenceForRequestReq,
  proto.request.GetSuggestedEvidenceForRequestRes,
  /**
   * @param {!proto.request.GetSuggestedEvidenceForRequestReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.GetSuggestedEvidenceForRequestRes.deserializeBinary
);


/**
 * @param {!proto.request.GetSuggestedEvidenceForRequestReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.GetSuggestedEvidenceForRequestRes)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.GetSuggestedEvidenceForRequestRes>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.getSuggestedEvidenceForRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/GetSuggestedEvidenceForRequest',
      request,
      metadata || {},
      methodDescriptor_Request_GetSuggestedEvidenceForRequest,
      callback);
};


/**
 * @param {!proto.request.GetSuggestedEvidenceForRequestReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.GetSuggestedEvidenceForRequestRes>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.getSuggestedEvidenceForRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/GetSuggestedEvidenceForRequest',
      request,
      metadata || {},
      methodDescriptor_Request_GetSuggestedEvidenceForRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.LinkSuggestedEvidenceToRequestReq,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_LinkSuggestedEvidenceToRequest = new grpc.web.MethodDescriptor(
  '/request.Request/LinkSuggestedEvidenceToRequest',
  grpc.web.MethodType.UNARY,
  proto.request.LinkSuggestedEvidenceToRequestReq,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.LinkSuggestedEvidenceToRequestReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.LinkSuggestedEvidenceToRequestReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.linkSuggestedEvidenceToRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/LinkSuggestedEvidenceToRequest',
      request,
      metadata || {},
      methodDescriptor_Request_LinkSuggestedEvidenceToRequest,
      callback);
};


/**
 * @param {!proto.request.LinkSuggestedEvidenceToRequestReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.linkSuggestedEvidenceToRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/LinkSuggestedEvidenceToRequest',
      request,
      metadata || {},
      methodDescriptor_Request_LinkSuggestedEvidenceToRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.ListRequestFindingsRequest,
 *   !proto.request.ListRequestFindingsResponse>}
 */
const methodDescriptor_Request_ListRequestFindings = new grpc.web.MethodDescriptor(
  '/request.Request/ListRequestFindings',
  grpc.web.MethodType.UNARY,
  proto.request.ListRequestFindingsRequest,
  proto.request.ListRequestFindingsResponse,
  /**
   * @param {!proto.request.ListRequestFindingsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.ListRequestFindingsResponse.deserializeBinary
);


/**
 * @param {!proto.request.ListRequestFindingsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.ListRequestFindingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.ListRequestFindingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.listRequestFindings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/ListRequestFindings',
      request,
      metadata || {},
      methodDescriptor_Request_ListRequestFindings,
      callback);
};


/**
 * @param {!proto.request.ListRequestFindingsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.ListRequestFindingsResponse>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.listRequestFindings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/ListRequestFindings',
      request,
      metadata || {},
      methodDescriptor_Request_ListRequestFindings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.UpsertRequestFindingRequest,
 *   !proto.request.RequestFinding>}
 */
const methodDescriptor_Request_UpsertRequestFinding = new grpc.web.MethodDescriptor(
  '/request.Request/UpsertRequestFinding',
  grpc.web.MethodType.UNARY,
  proto.request.UpsertRequestFindingRequest,
  proto.request.RequestFinding,
  /**
   * @param {!proto.request.UpsertRequestFindingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.RequestFinding.deserializeBinary
);


/**
 * @param {!proto.request.UpsertRequestFindingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.RequestFinding)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.RequestFinding>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.upsertRequestFinding =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/UpsertRequestFinding',
      request,
      metadata || {},
      methodDescriptor_Request_UpsertRequestFinding,
      callback);
};


/**
 * @param {!proto.request.UpsertRequestFindingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.RequestFinding>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.upsertRequestFinding =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/UpsertRequestFinding',
      request,
      metadata || {},
      methodDescriptor_Request_UpsertRequestFinding);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.DeleteRequestFindingRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_DeleteRequestFinding = new grpc.web.MethodDescriptor(
  '/request.Request/DeleteRequestFinding',
  grpc.web.MethodType.UNARY,
  proto.request.DeleteRequestFindingRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.DeleteRequestFindingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.DeleteRequestFindingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.deleteRequestFinding =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/DeleteRequestFinding',
      request,
      metadata || {},
      methodDescriptor_Request_DeleteRequestFinding,
      callback);
};


/**
 * @param {!proto.request.DeleteRequestFindingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.deleteRequestFinding =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/DeleteRequestFinding',
      request,
      metadata || {},
      methodDescriptor_Request_DeleteRequestFinding);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.RequestComment,
 *   !proto.request.RequestComment>}
 */
const methodDescriptor_Request_CreateRequestComment = new grpc.web.MethodDescriptor(
  '/request.Request/CreateRequestComment',
  grpc.web.MethodType.UNARY,
  proto.request.RequestComment,
  proto.request.RequestComment,
  /**
   * @param {!proto.request.RequestComment} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.RequestComment.deserializeBinary
);


/**
 * @param {!proto.request.RequestComment} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.RequestComment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.RequestComment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.createRequestComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/CreateRequestComment',
      request,
      metadata || {},
      methodDescriptor_Request_CreateRequestComment,
      callback);
};


/**
 * @param {!proto.request.RequestComment} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.RequestComment>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.createRequestComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/CreateRequestComment',
      request,
      metadata || {},
      methodDescriptor_Request_CreateRequestComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.ListRequestCommentsRequest,
 *   !proto.request.ListRequestCommentsResponse>}
 */
const methodDescriptor_Request_ListRequestComments = new grpc.web.MethodDescriptor(
  '/request.Request/ListRequestComments',
  grpc.web.MethodType.UNARY,
  proto.request.ListRequestCommentsRequest,
  proto.request.ListRequestCommentsResponse,
  /**
   * @param {!proto.request.ListRequestCommentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.ListRequestCommentsResponse.deserializeBinary
);


/**
 * @param {!proto.request.ListRequestCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.ListRequestCommentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.ListRequestCommentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.listRequestComments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/ListRequestComments',
      request,
      metadata || {},
      methodDescriptor_Request_ListRequestComments,
      callback);
};


/**
 * @param {!proto.request.ListRequestCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.ListRequestCommentsResponse>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.listRequestComments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/ListRequestComments',
      request,
      metadata || {},
      methodDescriptor_Request_ListRequestComments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.DeleteRequestCommentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_DeleteRequestComment = new grpc.web.MethodDescriptor(
  '/request.Request/DeleteRequestComment',
  grpc.web.MethodType.UNARY,
  proto.request.DeleteRequestCommentRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.DeleteRequestCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.DeleteRequestCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.deleteRequestComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/DeleteRequestComment',
      request,
      metadata || {},
      methodDescriptor_Request_DeleteRequestComment,
      callback);
};


/**
 * @param {!proto.request.DeleteRequestCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.deleteRequestComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/DeleteRequestComment',
      request,
      metadata || {},
      methodDescriptor_Request_DeleteRequestComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.CreateRequestWorkflowRequest,
 *   !proto.request.CreateRequestWorkflowResponse>}
 */
const methodDescriptor_Request_CreateRequestWorkflow = new grpc.web.MethodDescriptor(
  '/request.Request/CreateRequestWorkflow',
  grpc.web.MethodType.UNARY,
  proto.request.CreateRequestWorkflowRequest,
  proto.request.CreateRequestWorkflowResponse,
  /**
   * @param {!proto.request.CreateRequestWorkflowRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.CreateRequestWorkflowResponse.deserializeBinary
);


/**
 * @param {!proto.request.CreateRequestWorkflowRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.CreateRequestWorkflowResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.CreateRequestWorkflowResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.createRequestWorkflow =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/CreateRequestWorkflow',
      request,
      metadata || {},
      methodDescriptor_Request_CreateRequestWorkflow,
      callback);
};


/**
 * @param {!proto.request.CreateRequestWorkflowRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.CreateRequestWorkflowResponse>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.createRequestWorkflow =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/CreateRequestWorkflow',
      request,
      metadata || {},
      methodDescriptor_Request_CreateRequestWorkflow);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.MarkRequestCommentsAsReadRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Request_MarkRequestCommentsAsRead = new grpc.web.MethodDescriptor(
  '/request.Request/MarkRequestCommentsAsRead',
  grpc.web.MethodType.UNARY,
  proto.request.MarkRequestCommentsAsReadRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.request.MarkRequestCommentsAsReadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.request.MarkRequestCommentsAsReadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.markRequestCommentsAsRead =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/MarkRequestCommentsAsRead',
      request,
      metadata || {},
      methodDescriptor_Request_MarkRequestCommentsAsRead,
      callback);
};


/**
 * @param {!proto.request.MarkRequestCommentsAsReadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.markRequestCommentsAsRead =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/MarkRequestCommentsAsRead',
      request,
      metadata || {},
      methodDescriptor_Request_MarkRequestCommentsAsRead);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.ResolveSourceDisplayNamesRequest,
 *   !proto.request.ResolveSourceDisplayNamesResponse>}
 */
const methodDescriptor_Request_ResolveSourceDisplayNames = new grpc.web.MethodDescriptor(
  '/request.Request/ResolveSourceDisplayNames',
  grpc.web.MethodType.UNARY,
  proto.request.ResolveSourceDisplayNamesRequest,
  proto.request.ResolveSourceDisplayNamesResponse,
  /**
   * @param {!proto.request.ResolveSourceDisplayNamesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.ResolveSourceDisplayNamesResponse.deserializeBinary
);


/**
 * @param {!proto.request.ResolveSourceDisplayNamesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.ResolveSourceDisplayNamesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.ResolveSourceDisplayNamesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestClient.prototype.resolveSourceDisplayNames =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.Request/ResolveSourceDisplayNames',
      request,
      metadata || {},
      methodDescriptor_Request_ResolveSourceDisplayNames,
      callback);
};


/**
 * @param {!proto.request.ResolveSourceDisplayNamesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.ResolveSourceDisplayNamesResponse>}
 *     Promise that resolves to the response
 */
proto.request.RequestPromiseClient.prototype.resolveSourceDisplayNames =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.Request/ResolveSourceDisplayNames',
      request,
      metadata || {},
      methodDescriptor_Request_ResolveSourceDisplayNames);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.request.RequestInternalServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.request.RequestInternalServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.BulkCreateRequestsFromGapsRequest,
 *   !proto.request.DocumentRequests>}
 */
const methodDescriptor_RequestInternalService_BulkCreateRequestsFromGaps = new grpc.web.MethodDescriptor(
  '/request.RequestInternalService/BulkCreateRequestsFromGaps',
  grpc.web.MethodType.UNARY,
  proto.request.BulkCreateRequestsFromGapsRequest,
  proto.request.DocumentRequests,
  /**
   * @param {!proto.request.BulkCreateRequestsFromGapsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.DocumentRequests.deserializeBinary
);


/**
 * @param {!proto.request.BulkCreateRequestsFromGapsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.DocumentRequests)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.DocumentRequests>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestInternalServiceClient.prototype.bulkCreateRequestsFromGaps =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.RequestInternalService/BulkCreateRequestsFromGaps',
      request,
      metadata || {},
      methodDescriptor_RequestInternalService_BulkCreateRequestsFromGaps,
      callback);
};


/**
 * @param {!proto.request.BulkCreateRequestsFromGapsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.DocumentRequests>}
 *     Promise that resolves to the response
 */
proto.request.RequestInternalServicePromiseClient.prototype.bulkCreateRequestsFromGaps =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.RequestInternalService/BulkCreateRequestsFromGaps',
      request,
      metadata || {},
      methodDescriptor_RequestInternalService_BulkCreateRequestsFromGaps);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.UpdateRequestLinksRequest,
 *   !proto.request.DocumentRequest>}
 */
const methodDescriptor_RequestInternalService_UpdateRequestLinks = new grpc.web.MethodDescriptor(
  '/request.RequestInternalService/UpdateRequestLinks',
  grpc.web.MethodType.UNARY,
  proto.request.UpdateRequestLinksRequest,
  proto.request.DocumentRequest,
  /**
   * @param {!proto.request.UpdateRequestLinksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.DocumentRequest.deserializeBinary
);


/**
 * @param {!proto.request.UpdateRequestLinksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.DocumentRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.DocumentRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestInternalServiceClient.prototype.updateRequestLinks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.RequestInternalService/UpdateRequestLinks',
      request,
      metadata || {},
      methodDescriptor_RequestInternalService_UpdateRequestLinks,
      callback);
};


/**
 * @param {!proto.request.UpdateRequestLinksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.DocumentRequest>}
 *     Promise that resolves to the response
 */
proto.request.RequestInternalServicePromiseClient.prototype.updateRequestLinks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.RequestInternalService/UpdateRequestLinks',
      request,
      metadata || {},
      methodDescriptor_RequestInternalService_UpdateRequestLinks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.RaiseRequestRequest,
 *   !proto.request.DocumentRequest>}
 */
const methodDescriptor_RequestInternalService_RaiseRequest = new grpc.web.MethodDescriptor(
  '/request.RequestInternalService/RaiseRequest',
  grpc.web.MethodType.UNARY,
  proto.request.RaiseRequestRequest,
  proto.request.DocumentRequest,
  /**
   * @param {!proto.request.RaiseRequestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.DocumentRequest.deserializeBinary
);


/**
 * @param {!proto.request.RaiseRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.DocumentRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.DocumentRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestInternalServiceClient.prototype.raiseRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.RequestInternalService/RaiseRequest',
      request,
      metadata || {},
      methodDescriptor_RequestInternalService_RaiseRequest,
      callback);
};


/**
 * @param {!proto.request.RaiseRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.DocumentRequest>}
 *     Promise that resolves to the response
 */
proto.request.RequestInternalServicePromiseClient.prototype.raiseRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.RequestInternalService/RaiseRequest',
      request,
      metadata || {},
      methodDescriptor_RequestInternalService_RaiseRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.CommentOnRequestRequest,
 *   !proto.request.RequestComment>}
 */
const methodDescriptor_RequestInternalService_CommentOnRequest = new grpc.web.MethodDescriptor(
  '/request.RequestInternalService/CommentOnRequest',
  grpc.web.MethodType.UNARY,
  proto.request.CommentOnRequestRequest,
  proto.request.RequestComment,
  /**
   * @param {!proto.request.CommentOnRequestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.RequestComment.deserializeBinary
);


/**
 * @param {!proto.request.CommentOnRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.RequestComment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.RequestComment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestInternalServiceClient.prototype.commentOnRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.RequestInternalService/CommentOnRequest',
      request,
      metadata || {},
      methodDescriptor_RequestInternalService_CommentOnRequest,
      callback);
};


/**
 * @param {!proto.request.CommentOnRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.RequestComment>}
 *     Promise that resolves to the response
 */
proto.request.RequestInternalServicePromiseClient.prototype.commentOnRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.RequestInternalService/CommentOnRequest',
      request,
      metadata || {},
      methodDescriptor_RequestInternalService_CommentOnRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.request.UpdateRequestStatusRequest,
 *   !proto.request.DocumentRequest>}
 */
const methodDescriptor_RequestInternalService_UpdateRequestStatus = new grpc.web.MethodDescriptor(
  '/request.RequestInternalService/UpdateRequestStatus',
  grpc.web.MethodType.UNARY,
  proto.request.UpdateRequestStatusRequest,
  proto.request.DocumentRequest,
  /**
   * @param {!proto.request.UpdateRequestStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.request.DocumentRequest.deserializeBinary
);


/**
 * @param {!proto.request.UpdateRequestStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.request.DocumentRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.request.DocumentRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.request.RequestInternalServiceClient.prototype.updateRequestStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/request.RequestInternalService/UpdateRequestStatus',
      request,
      metadata || {},
      methodDescriptor_RequestInternalService_UpdateRequestStatus,
      callback);
};


/**
 * @param {!proto.request.UpdateRequestStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.request.DocumentRequest>}
 *     Promise that resolves to the response
 */
proto.request.RequestInternalServicePromiseClient.prototype.updateRequestStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/request.RequestInternalService/UpdateRequestStatus',
      request,
      metadata || {},
      methodDescriptor_RequestInternalService_UpdateRequestStatus);
};


module.exports = proto.request;

